import { TENANT_STATUS } from '../tenant';
import type { Tenant } from '../tenant';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class TenantFactory extends ObjectFactory<Tenant> {
  protected getDefaults(): Tenant {
    return {
      ...baseDocumentFactory.build(),
      code: 'tenant-code',
      country: 'FR',
      initializedAt: null,
      language: 'fr',
      mainContact: {
        email: 'contact@example.com',
        firstName: 'Jean',
        lastName: 'Dupont',
      },
      name: 'Test Tenant',
      segment: 'delivery-service-partner',
      status: TENANT_STATUS.INACTIVE,
    };
  }
}

export type { Tenant };
export const tenantFactory = new TenantFactory();
